<template lang="pug">
.content-center
  .overlay
  .back-btn.mb-2(@click="back()")
    i.fa-solid.fa-left-long
    |  {{ $t("ui.back") }} 
  template(v-if="$store.getters.language == 'cn'")
    cnContent
  template(v-else-if="$store.getters.language == 'vi'")
    viContent
  template(v-else-if="$store.getters.language == 'th'")
    thContent
  template(v-else-if="$store.getters.language == 'id'")
    idContent
  template(v-else-if="$store.getters.language == 'kr'")
    krContent
  template(v-else)
    enContent
</template>

<script>
import enContent from "@/components/mobile/rules/en/sepak-takraw";
import cnContent from "@/components/mobile/rules/cn/sepak-takraw";
import viContent from "@/components/mobile/rules/vi/sepak-takraw";
import thContent from "@/components/mobile/rules/th/sepak-takraw";
import idContent from "@/components/mobile/rules/id/sepak-takraw";
import krContent from "@/components/mobile/rules/kr/sepak-takraw";

export default {
  components: {
    enContent,
    cnContent,
    viContent,
    thContent,
    idContent,
    krContent
  },
  computed: {},
  methods: {
    back() {
      this.$router.push("/betting_rules");
    }
  }
};
</script>
